import { render, staticRenderFns } from "./privacy1.vue?vue&type=template&id=1469fedc&scoped=true&"
import script from "./privacy1.vue?vue&type=script&lang=js&"
export * from "./privacy1.vue?vue&type=script&lang=js&"
import style0 from "./privacy1.vue?vue&type=style&index=0&id=1469fedc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1469fedc",
  null
  
)

export default component.exports